<template></template>

<script>
import axios from "axios";
import ChartistLine from "./chartist-line.vue";
import loadingImage from 'images/spinner.svg';
import { isInViewport } from "../../helpers/isInViewport"

export default {
  components: { ChartistLine },
  props: ["companyCreatedAt"],
  data() {
    return {
      year: moment().year(),
      years: [],
      chartsData: {
        received_paid: null,
        quotes: null,
        profit: null,
      },
      averageTicketTotal: null,
      downloadingQuotesReport: false,
      isFetched: false,
      hasError: false,
      loadingImage,
    };
  },
  watch: {
    year() {
      this.fetch();
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll()
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let years = [];
    for (
      let i = moment(this.companyCreatedAt).year();
      i <= moment().year();
      i++
    ) {
      years.push(i);
    }
    this.years = years;
  },
  computed: {
    receivedTotal() {
      if (this.chartsData["received_paid"]) {
        return this.chartsData["received_paid"]["series"][0]
          .reduce((partial_sum, a) => partial_sum + a)
          .toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          });
      }
    },
    paidTotal() {
      if (this.chartsData["received_paid"]) {
        return this.chartsData["received_paid"]["series"][1]
          .reduce((partial_sum, a) => partial_sum + a)
          .toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          });
      }
    },
    quotesTotal() {
      if (this.chartsData["quotes"]) {
        return this.chartsData["quotes"]["series"][0].reduce(
          (partial_sum, a) => partial_sum + a
        );
      }
    },
    approvedQuotesTotal() {
      if (this.chartsData["quotes"]) {
        return this.chartsData["quotes"]["series"][1].reduce(
          (partial_sum, a) => partial_sum + a
        );
      }
    },
    profitTotal() {
      if (this.chartsData["profit"]) {
        return this.chartsData["profit"]["series"][0]
          .reduce((partial_sum, a) => partial_sum + a)
          .toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          });
      }
    },
  },
  methods: {
    fetch() {
      axios.get(`/financial/charts?year=${this.year}`).then((response) => {
        this.chartsData = response.data.charts;
        this.averageTicketTotal = response.data.average_ticket_total;
        this.hasError = false;
      }).catch(() => {
        this.hasError = true;
      }).finally(() => {
        this.isFetched = true;
      });
    },
    downloadQuotesReport(event) {
      if (this.downloadingQuotesReport) {
        return;
      }
      this.downloadingQuotesReport = true;
      axios
        .get(event.target.href, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "orcamentos.xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error)
        .finally(() => {
          this.downloadingQuotesReport = false;
        });
    },
    handleScroll() {
      if (this.isFetched) {
        return;
      }
      if (isInViewport(this.$refs.container, true)) {
        this.fetch();
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
  },
};
</script>
